export const slugify = (text: string) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') //NOSONAR   
    .replace(/[^\w-]+/g, '') //NOSONAR   
    .replace(/--+/g, '-'); //NOSONAR  
};
